import styles from "@/styles/Video.module.scss";
import CourseInfo from "./CourseInfo";
import ProductInfo from "./ProductInfo";

export default function NoEntitled({ watch }) {
  const { howtoPlay, episode } = watch;

  if (episode?.rights_control_type !== "entitled_only") return null;
  if (howtoPlay.courses.length > 0) {
    return (
      <div className={styles.noentitled}>
        <h3>この作品をご視聴いただくには下記の月額商品の購入が必要です。</h3>
        <div className={styles.contractInfo}>
          {howtoPlay.courses.map((course) => (
            <CourseInfo
              withLink
              key={`course-${course.id}`}
              course={course}
              isLoggedIn={true}
            />
          ))}
        </div>
      </div>
    );
  }
  if (howtoPlay.products.length > 0) {
    const header =
      howtoPlay.products.length > 1
        ? "この作品をご視聴いただくには以下いずれかの購入が必要です。"
        : "この作品をご視聴いただくには別途料金が必要です。";
    return (
      <div className={styles.noentitled}>
        <h3>{header}</h3>
        <p className={styles.caption}>
          利用にあたっては規約同意とお支払い方法の登録が必要です。
        </p>
        <div>
          {howtoPlay.products.map((product) => (
            <ProductInfo
              withLink
              key={`product-${product.id}`}
              product={product}
              rights={howtoPlay.rights}
              isLoggedIn={true}
            />
          ))}
        </div>
      </div>
    );
  }
  return (
    <div className={styles.noentitled}>
      <h3>この作品を視聴いただくのに必要な購入・商品がありません</h3>
    </div>
  );
}
